import React, { useState, useEffect } from 'react';
import { ChevronRightIcon } from 'icons';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames/bind';
import styles from 'componets/leftbar/index.module.scss';
import { Link } from 'react-router-dom';
import { privacyUrl, termsUrl } from 'config/config';
import avatar from 'images/icon-avatar.svg';
import { useLeftBar } from 'componets/leftbar/useLeftBar';
import analytics from 'service/analytics';
import {
  PAGE_PROFILE,
  PAGE_DRIVERS,
  PAGE_LICENSE_PLATES,
  PAGE_ORDERS,
  PAGE_PAYMENT,
  PAGE_STATS,
  PAGE_COUPON,
  PAGE_POINTS,
  useAppContext,
} from 'use-app';

const cx = classnames.bind(styles);

const LeftBar = ({ announcementBoard = null }) => {
  const [isSmallSize, setIsSmallSize] = useState(false);
  const { state: appState } = useAppContext();
  const { state } = useLeftBar();
  const history = useHistory();

  const eventFactory = key => {
    switch (key) {
      case PAGE_PROFILE:
        return '側欄選單_帳號資訊_click';
      case PAGE_DRIVERS:
        return '側欄選單_駕駛帳號_click';
      case PAGE_LICENSE_PLATES:
        return '側欄選單_付款車牌_click';
      case PAGE_PAYMENT:
        return '側欄選單_預存金帳戶_click';
      case PAGE_ORDERS:
        return '側欄選單_匯出明細_click';
      case PAGE_STATS:
        return '側欄選單_消費統計_click';
      case PAGE_COUPON:
        return '側欄選單_企業優惠_click';
      case PAGE_POINTS:
        return '側欄選單_企業紅利_click';
      default:
        return '';
    }
  };

  const AccountInfo = () => {
    if (state.subAccountName) {
      return (
        <>
          <div className={styles.name}>企業 {state.username}</div>
          <div className={styles.subAccountName}>子帳號 {state.subAccountName}</div>
        </>
      );
    } else {
      return <div className={styles.name}>企業 {state.username}</div>;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const result = window.matchMedia('(max-width: 768px)');

      setIsSmallSize(result.matches);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={styles['sticky-container']}>
      <div className={styles.leftBar}>
        <div className={styles.top}>
          <div className={styles.head}>
            <div className={styles.avatar}>
              <img src={avatar} alt="avatar" />
            </div>
            <div className={styles.info}>
              <AccountInfo />
            </div>
          </div>
          <ul className={styles.companyList}>
            {state.items.map(x => {
              const activeStyles = cx({
                active: appState.currentPage === x.key,
              });

              return (
                <li
                  key={x.key}
                  className={`${x.key} ${activeStyles}`}
                  onClick={() => {
                    analytics.track(eventFactory(x.key));
                    history.push(`/${x.key}`);
                  }}
                >
                  <div className={styles['list-item-inner-container']}>
                    {!isSmallSize && x.icon}
                    <Link>{x.value}</Link>
                    {!isSmallSize && (
                      <ChevronRightIcon width={16} height={16} color="#dddddd" styles={{ marginLeft: 'auto' }} />
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={styles.footer}>
          <a href={privacyUrl}>隱私權政策</a>．<a href={termsUrl}>服務條款</a>
        </div>
      </div>
      {announcementBoard}
    </div>
  );
};

export default LeftBar;
